import React from "react";
import "./footer.scss";
import { FaTelegram, FaVk } from "react-icons/fa";
import Logo from "../../assets/logo-footer.png";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.includes("/admin-panel");

  const handleClick = () => {
    window.open('https://dzen.ru/ncpti', '_blank');
  };


  return (
    <div className={`footer ${isAdminRoute && 'footer__hide'}`}>
      <div className='footer-main'>
      <div className="upper-block">
        <section className="footer-logo">
          <Link to="/">
            <img
              src={Logo}
              alt="Логотип НЦПТИ белый"
              className="footer-logo__img"
            />
          </Link>
          <p style={{color:'#898989', marginTop: '2rem'}}>Версия 2.3</p>
          {/*<input type="search" placeholder='Поиск....'/>*/}
        </section>
        <section className="footer-menu">
          <Link to="novosti">Новости</Link>
          <Link to="meropriyatiya">Наши мероприятия</Link>
          <Link to="uslugi">Услуги</Link>
          <Link to="onlajn-kursy">Онлайн-курсы</Link>
          <Link to="materialy">Материалы</Link>
          <Link to="obzor">Обзор.НЦПТИ</Link>
        </section>
        <section className="footer-contacts">
          <a href="tel:88632012822">+7(863)201-28-22</a>
          <a href="mailto:info@ncpti.ru">info@ncpti.ru</a>
          <p className="footer-p__contacts">344011, г. Ростов-на-Дону</p>
          <p className="footer-p__contacts">ул. Города Волос, д.6, а/я 488</p>
          <div className="footer__social-icons">
            <a href="https://vk.com/ncpti_rnd" target="_blank" rel="noreferrer">
              <FaVk className="social-icon"/>
            </a>
            <a href="https://t.me/ncpti" target="_blank" rel="noreferrer">
              <FaTelegram className="social-icon"/>
            </a>
            <a onClick={handleClick} target="_blank" rel="noreferrer" title="Yandex Dzen" style={{cursor:'pointer'}}>
              <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.3143 14.3143C12.4286 16.26 12.2914 18.6857 12.1286 24C17.0829 24 20.5029 23.9829 22.2686 22.2686C23.9829 20.5029 24 16.92 24 12.1286C18.6857 12.3 16.26 12.4286 14.3143 14.3143ZM0 12.1286C0 16.92 0.0171428 20.5029 1.73143 22.2686C3.49714 23.9829 6.91714 24 11.8714 24C11.7 18.6857 11.5714 16.26 9.68571 14.3143C7.74 12.4286 5.31429 12.2914 0 12.1286ZM11.8714 0C6.92571 0 3.49714 0.0171428 1.73143 1.73143C0.0171428 3.49714 0 7.08 0 11.8714C5.31429 11.7 7.74 11.5714 9.68571 9.68571C11.5714 7.74 11.7086 5.31429 11.8714 0ZM14.3143 9.68571C12.4286 7.74 12.2914 5.31429 12.1286 0C17.0829 0 20.5029 0.0171428 22.2686 1.73143C23.9829 3.49714 24 7.08 24 11.8714C18.6857 11.7 16.26 11.5714 14.3143 9.68571Z"
                    fill="#C1C2D1"/>
              </svg>
              {/*<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 33 32"*/}
              {/*     fill="none" className="social-icon_dzen">*/}
              {/*  <rect x="0.359375" width="32" height="32" rx="16"></rect>*/}
              {/*  <path*/}
              {/*      d="M17.9022 17.5429C16.6451 18.84 16.5537 20.4571 16.4451 24C19.7479 24 22.0279 23.9886 23.2051 22.8457C24.3479 21.6686 24.3594 19.28 24.3594 16.0857C20.8165 16.2 19.1994 16.2857 17.9022 17.5429ZM8.35938 16.0857C8.35938 19.28 8.3708 21.6686 9.51366 22.8457C10.6908 23.9886 12.9708 24 16.2737 24C16.1594 20.4571 16.0737 18.84 14.8165 17.5429C13.5194 16.2857 11.9022 16.1943 8.35938 16.0857ZM16.2737 8C12.9765 8 10.6908 8.01143 9.51366 9.15429C8.3708 10.3314 8.35938 12.72 8.35938 15.9143C11.9022 15.8 13.5194 15.7143 14.8165 14.4571C16.0737 13.16 16.1651 11.5429 16.2737 8ZM17.9022 14.4571C16.6451 13.16 16.5537 11.5429 16.4451 8C19.7479 8 22.0279 8.01143 23.2051 9.15429C24.3479 10.3314 24.3594 12.72 24.3594 15.9143C20.8165 15.8 19.1994 15.7143 17.9022 14.4571Z"*/}
              {/*      fill="white"></path>*/}
              {/*  <path*/}
              {/*      d="M24.3594 16.0857V15.9143C20.8165 15.8 19.1994 15.7143 17.9022 14.4571C16.6451 13.16 16.5537 11.5429 16.4451 8H16.2737C16.1594 11.5429 16.0737 13.16 14.8165 14.4571C13.5194 15.7143 11.9022 15.8057 8.35938 15.9143V16.0857C11.9022 16.2 13.5194 16.2857 14.8165 17.5429C16.0737 18.84 16.1651 20.4571 16.2737 24H16.4451C16.5594 20.4571 16.6451 18.84 17.9022 17.5429C19.1994 16.2857 20.8165 16.1943 24.3594 16.0857Z"*/}
              {/*  ></path>*/}
              {/*</svg>*/}

            </a>
            <a
                href="https://rutube.ru/channel/25826771/"
                target="_blank"
                rel="noreferrer"
            >
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" className={'social-icon'}
                   xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_12_17218)">
                  <path
                      d="M15.3996 12.0699H8.17243V9.21004H15.3996C15.8218 9.21004 16.1153 9.28362 16.2626 9.41212C16.4099 9.54062 16.5012 9.77894 16.5012 10.1271V11.154C16.5012 11.5208 16.4099 11.7591 16.2626 11.8876C16.1153 12.0161 15.8218 12.071 15.3996 12.071V12.0699ZM15.8954 6.51379H5.10742V18.7441H8.17243V14.7651H13.8209L16.5012 18.7441H19.9334L16.9783 14.7464C18.0678 14.585 18.557 14.2511 18.9604 13.7009C19.3639 13.1506 19.5662 12.2709 19.5662 11.0969V10.1798C19.5662 9.48351 19.4925 8.93328 19.3639 8.51154C19.2353 8.08981 19.0154 7.72299 18.7032 7.39351C18.3734 7.0816 18.0062 6.86194 17.5653 6.71478C17.1245 6.58628 16.5737 6.5127 15.8954 6.5127V6.51379Z"
                      fill="white"></path>
                  <path
                      d="M36.9843 0.396693C36.9843 7.15191 31.5081 12.6281 24.7529 12.6281C23.3795 12.6281 22.0589 12.4017 20.8265 11.9843C20.8529 11.6936 20.8645 11.3965 20.8645 11.0966V10.1795C20.8645 9.40085 20.7832 8.71448 20.6058 8.13279C20.4145 7.50551 20.0863 6.96566 19.6459 6.50089L19.6215 6.47509L19.5957 6.45067C19.1264 6.00685 18.5945 5.69001 17.9772 5.48396L17.9535 5.47603L17.9295 5.46903C17.3419 5.29778 16.6636 5.21512 15.8965 5.21512H14.5992V5.21622H13.5076C12.8729 3.73729 12.5215 2.10804 12.5215 0.396693C12.5215 -6.35853 17.9977 -11.8347 24.7529 -11.8347C31.5081 -11.8347 36.9843 -6.35853 36.9843 0.396693Z"
                      fill="white"></path>
                </g>
                <rect x="0.474846" y="0.582512" width="24.0912" height="24.0912" rx="5.76463" stroke="white"
                      strokeWidth="0.371567"></rect>
                <defs>
                  <clipPath id="clip0_12_17218">
                    <rect x="0.289062" y="0.396729" width="24.4628" height="24.4628" rx="5.95041" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </section>
      </div>
        <div className="lower-block">
          <section className="footer__text-info">
            <a href="/politika-konfidenczialnosti.pdf" download>
              Политика конфиденциальности
            </a>
            <br/>
           
            <p className="footer-p__info">
              *Упоминаемые на странице ресурсы Instagram, Facebook, WhatsApp
              принадлежат компании Meta, признанной экстремистской на территории
              Российской Федерации
            </p>
            <p className="footer-p__info">
              «Национальный центр информационного противодействия терроризму и
              экстремизму в образовательной среде и сети Интернет»
            </p>
            <p className="footer-p__info">
              СМИ «Веб-сайт НЦПТИ» зарегистрировано в Федеральной службе по
              надзору в сфере связи, информационных технологий и массовых
              коммуникаций (Роскомнадзор) 7 марта 2013 г.
              <br/>
              Свидетельство о регистрации Эл № ФС77-53109
              <br/>
              Учредитель — ФГАНУ НИИ «Спецвузавтоматика»
              <br/>
              Главный редактор — Быкадорова Александра Сергеевна, email:
              asbyk@ncpti.ru
              <br/>
              Адрес редакции: 344011, Ростов-на-Дону, ул. Города Волос, д.6.
              <br/>
              Тел. редакции (863) 201-28-22
              <br/>
              Настоящий ресурс может содержать материалы 18+
            </p>
            <p>
              Все права на размещенную на сайте информацию принадлежат
              Национальному центру информационного противодействия терроризму и
              экстремизму в образовательной среде и сети Интернет. Материалы могут
              быть использованы только с обязательным размещением активной ссылки
              на первоисточник.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Footer;
